import { Component, createRef } from "react";
import { connect } from "react-redux";
import {set_datapage} from '@ora/recursos/src/redux/actions/DataPageAction'
import '@loadingio/loading.css/dist/loading.css'

import { 
  Card,
  Section,
} from 'react-bulma-components';
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import MediaColumnFicha from "layouts/mainsection/components/MediaColumnFicha";


class ComercioShow extends Component{
  requestInit = null
  state = {
    data: null
  }
  constructor (props) {
    super(props)
    this.requestInit = axios.CancelToken.source()
    
    this.props.set_datapage({ titulo: 'Ficha de exportaciones e importaciones',
    isbackend:false,
    breadcrumb:[
        {name:"Intranet",url:"#"},
        {name:"Exportaciones",url:"#"},
        {name:"Ficha de exportaciones e importaciones",url:"#",active:true},
    ]});
    this.spinnerLoad = createRef()
    
    axios.get(baseUrl('cites/exportaciones/' + this.props.match.params.idrecurso + '?m=format'),  { cancelToken: this.requestInit.token }).then(res => {
      if (res.data.success) {
          this.setState({
              data: res.data.data
          })
      }
      this.spinnerLoad.current.classList.add('is-hidden')
    })

  }
  componentWillUnmount() {
    // this._isMounted = false;
    if (this.requestInit) this.requestInit.cancel()
  }
  FnDetallesFicha = () => {
    // let t = []
    // for(let item in this.state.data) {
    //   console.log(item)
    //   t.push({item, value: this.state.data[item]})
    // }
    // console.log(t)
    return this.state.data || []
  }
  OnClick_regresar = () => {
    
    // this.props.history.goBack()
    this.props.history.goBack()

  }
  render () {
    return (
      <div className="is-main-section">
      <Card>
        <Card.Header>
           <Card.Header.Title>
               <span className="icon"><i className="fas fa-file-invoice"></i></span>Datos
           </Card.Header.Title>
          
        </Card.Header>
        <Card.Content>
            <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
              </div>
      <div className="media-list">
        { this.FnDetallesFicha().sort((a, b) => {
          if (a.order > b.order) {
            return 1;
          }
          if (a.order < b.order) {
            return -1;
          }
          // a must be equal to b
          return 0;
        }).map((item, index) => {
            let detalle = item.value
            // console.log(item.key)
            if (item.key === 'duc_txt_file_format') {
              detalle = (<a href={ item.value } className="button is-primary"><span className="icon"><i className="mdi mdi-download default"></i></span><span>Descargar</span></a>)
              
            }
            return item.show && <MediaColumnFicha key={ index } columna={ item.name } detalle={ detalle } ></MediaColumnFicha>
        })}
        
      
      </div>
      <hr/>
             <div className="field is-horizontal">
               <div className="field-label is-normal" />
               <div className="field-body">
                 <div className="field">
                   <div className="field">
                     <div className="field-body">
                       <div className="field has-text-right">
                         <div className="control">
                           <button onClick={ this.OnClick_regresar } type="button"
                             className="button is-danger"><span>Regresar</span></button></div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
      </Card.Content>
      </Card>
      </div>
    )
  }
}

export default connect(null, {set_datapage})(ComercioShow)